module.exports = __webpack_public_path__ + "static/media/kian_baghai.c0168e85.png";